import { render, staticRenderFns } from "./PaletteAdd.vue?vue&type=template&id=41493ceb&scoped=true"
import script from "./PaletteAdd.vue?vue&type=script&lang=js"
export * from "./PaletteAdd.vue?vue&type=script&lang=js"
import style0 from "./PaletteAdd.vue?vue&type=style&index=0&id=41493ceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41493ceb",
  null
  
)

export default component.exports